<template>
  <DialogoFormulario
    ref="dialogo"
    title="Nova Locação"
    :width="400"
    :handler="handleSubmit"
  >
    <template v-slot="{ form, errors }">
      <BuscarOuCadastrarLocalDeEstoque
        label="Local de estoque destino"
        v-model="form.local_estoque"
        outlined
      />
    </template>
  </DialogoFormulario>
</template>

<script>
import DialogoFormulario from "@/components/dialogos/DialogoFormulario.vue";
import BuscarOuCadastrarLocalDeEstoque from "../localEstoque/BuscarOuCadastrarLocalDeEstoque.vue";
import api from "@/services/locacoes.js";
import alerts from "@/mixins/alerts.js";

export default {
  mixins: [alerts],

  components: {
    DialogoFormulario,
    BuscarOuCadastrarLocalDeEstoque
  },

  data() {
    return {};
  },

  methods: {
    abrir() {
      this.$refs.dialogo.open();
    },
    fechar() {
      this.$refs.dialogo.close();
    },
    async handleSubmit(form) {
      const locacao = await api.locacoes.iniciar({
        cliente_id: form.local_estoque.cliente_id,
        local_estoque_destino_id: form.local_estoque.id
      });
      this.sendMessage("Locação aberta com sucesso");
      this.$emit("locacaoAberta", locacao);
    }
  }
};
</script>
